import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FieldMessageComponent } from './components/field-message/field-message.component';
import { LoadingComponent } from './components/loading/loading.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { SystemLoaderComponent } from './components/system-loader.component';
import { CpfFormatterPipe } from './pipe/cpf-formatter.pipe';
import { FilterBoxComponent } from './components/filter-box/filter-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { TableComponent } from './table/table.component';
import { FilterComponent } from './filter/filter.component';
import { EditFormComponent } from './edit-form/edit-form.component';
import { ViewFormComponent } from './view-form/view-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { NgxEditorModule } from 'ngx-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TextCustomization } from './services/text-customization.service';
import { MatNativeDateModule } from '@angular/material/core';
import { CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { DecodeURIComponentPipe } from './pipe/decode-uri.pipe';

@NgModule({
  declarations: [
    SystemLoaderComponent,
    LoadingComponent,
    WelcomeComponent,
    FieldMessageComponent,
    CpfFormatterPipe,
    FilterBoxComponent,
    TableComponent,
    FilterComponent,
    EditFormComponent,
    ViewFormComponent,
    DecodeURIComponentPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSelectModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatTableModule,
    MatDatepickerModule,
    RouterModule,
    NgxEditorModule,
    MatSlideToggleModule,
    DragDropModule,
    MatNativeDateModule,
  	CdkDropList,
    CdkDrag,
  ],
  exports: [
    SystemLoaderComponent,
    LoadingComponent,
    WelcomeComponent,
    FieldMessageComponent,
    CpfFormatterPipe,
    FilterBoxComponent,
    TableComponent,
    FilterComponent,
    EditFormComponent,
    ViewFormComponent,
    DecodeURIComponentPipe,
  ],
  providers: [TextCustomization],
})
export class SharedModule { }
